import { createSlice } from '@reduxjs/toolkit';

import { OverlayGroupsState } from '@/redux/overlayGroup/overlayGroup.types';
import {
  deleteOverlayGroupReducer,
  getOverlayGroupReducer,
  getOverlayGroupsReducer,
} from '@/redux/overlayGroup/overlayGroup.reducers';

const initialState: OverlayGroupsState = {
  data: [],
  loading: 'idle',
  error: { name: '', message: '' },
};

const overlayGroupsSlice = createSlice({
  name: 'overlayGroup',
  initialState,
  reducers: {
    deleteOverlayGroup: deleteOverlayGroupReducer,
  },

  extraReducers: builder => {
    getOverlayGroupsReducer(builder);
    getOverlayGroupReducer(builder);
  },
});

export const { deleteOverlayGroup } = overlayGroupsSlice.actions;

export default overlayGroupsSlice.reducer;
